var _class;
import { observer } from 'mobx-react';
import React from 'react';
import { withI18n } from '@udemy/i18n';
import { withUDData } from '@udemy/ud-data';
import { WishlistButton } from './wishlist-button.react-component';
let InternalWishlist = observer(_class = class InternalWishlist extends React.Component {
  render() {
    const {
      wishlistStore,
      round,
      isMobile,
      // isCourseInUserSubscription,
      // uiRegion,
      udData,
      gettext,
      square,
      ...givenButtonProps
    } = this.props;
    const {
      Config,
      me
    } = udData;
    if (!Config.features.wishlist || me.isLoading) {
      return null;
    }
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(WishlistButton, Object.assign({
      "data-purpose": "toggle-wishlist",
      isWishlisted: wishlistStore.isWishlisted,
      isLoading: wishlistStore.apiRequestIsLoading,
      onClick: wishlistStore.toggleWishlist,
      round: round,
      wishlistCta: isMobile ? gettext('Add to Wishlist') : gettext('Wishlist'),
      square: square
    }, givenButtonProps)));
  }
}) || _class;
export const Wishlist = withI18n(withUDData(InternalWishlist));
//# sourceMappingURL=wishlist.react-component.js.map